export const collectionGroupItemIcons = [
    "newspaper",
    "finance-daily",
    "newspaper-history",
    "extract",
    "extract-jr",
    "extract-history",
    "learn",
    "pass",
    "van-dale",
    "film",
    "music",
    "consumentenbond",
    "book-jr",
    "winkler-prins",
    "winkler-prins-jr",
    "research",
    "video"
];
